import React, { useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { storeHasNewNotification } from 'store/reducers/mainSlice';
import { storeInLocalStore } from 'store/reducers/mainSlice';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { Link, useLocation } from 'react-router-dom';
import { Avatar } from '@mui/material';
import NotificationDropdown from 'ui-component/NotificationDropdown/NotificationDropdown';

import Tags from 'ui-component/Tags';
import config from '../../../config';
import { notificationTextToPlainText } from 'helpers/common.helper';
import { HiOutlineDeviceMobile } from 'react-icons/hi';
import {
	NotificationIcon,
	ArrowRightIcon,
	QuotationIcon,
	SalesOrderIcon,
	InvoiceIcon,
	ContactsIcons,
	PurchaseListIcon,
	SerialsIcon,
	TrackingCodeIcon,
} from 'ui-component/custom-icons/icons';
import { IoIosArrowDown } from 'react-icons/io';
import { IoSearchOutline } from 'react-icons/io5';
import QuickActions from 'ui-component/quick-actions/QuickActions';
import ProfileMenuBlock from 'ui-component/ProfileMenuBlock';
import { Skeleton } from '@mui/material';
import TaskSection from 'ui-component/TaskSection';
import { CountriesUIFlag } from 'ui-component/CountriesUI';

window.Pusher = require('pusher-js');

// ✅ Clear
const NavBar = ({ onSearchToggle }) => {
	const notiRef = useRef(null);
	const profileIconRef = useRef(null);
	const notiBtnRef = useRef(null);
	const pageTitle = useSelector((state) => state.main.pageTitle);
	const userName = useSelector((state) => state.main.user.first_name);
	const [taskPanelOpened, setTaskPanelOpened] = useState(false);
	const userDetails = useSelector((state) => state.main.user);
	const userFName = userDetails?.first_name || '';
	const userLName = userDetails?.last_name || '';
	const userID = userDetails?.id || '';
	const hasNewNotification = userDetails?.hasNewNotification || false;
	const profilePhoto = userDetails?.profile_photo_url || '';
	
	const location = useLocation();
    const [searchTimeout, setSearchTimeout] = useState(null);

	const [showNotifications, setShowNotifications] = useState(false);
	const history = useNavigate();
	const dispatch = useDispatch();
	const [showSearchContainer, setShowSearchContainer] = useState(false);

	const [showProfileMenu, setShowProfileMenu] = useState(false);
	const searchContainerRef = useRef(null);
	const mainNavRef = useRef(null);
	const [generalSearchValue, setGeneralSearchValue] = useState('');
	const [isSearchInProgress, setIsSearchInProgress] = useState(false);

	const [showQuotationSection, setShowQuotationSection] = useState(true);
	const [showSalesOrderSection, setShowSalesOrderSection] = useState(true);
	const [showInvoiceSection, setShowInvoiceSection] = useState(true);
	const [showContactSection, setShowContactSection] = useState(true);
	const [showProductSection, setShowProductSection] = useState(true);
	const [showPurchaseOrderSection, setShowPurchaseOrderSection] = useState(true);
	const [showImeiSection, setShowImeiSection] = useState(true);
	const [showTrackingNumberSection, setShowTrackingNumberSection] = useState(true);

	const [searchResultQuotation, setSearchResultQuotation] = useState([]);
	const [searchResultSalesOrder, setSearchResultSalesOrder] = useState([]);
	const [searchResultInvoice, setSearchResultInvoice] = useState([]);
	const [searchResultContact, setSearchResultContact] = useState([]);
	const [searchResultProduct, setSearchResultProduct] = useState([]);
	const [searchResultPurchaseOrder, setSearchResultPurchaseOrder] = useState([]);
	const [searchResultImei, setSearchResultImei] = useState([]);
	const [searchResultTrackingNumber, setSearchResultTrackingNumber] = useState([]);

	const getGeneralSearch = () => {
		setIsSearchInProgress(true)
		api.getGenerealSearchContent({search: generalSearchValue.trim() }).then((res) => {
			if (res?.status) {
				setShowQuotationSection(res?.data?.has_quotations);
				setShowSalesOrderSection(res?.data?.has_sales_orders);
				setShowInvoiceSection(res?.data?.has_invoices);
				setShowContactSection(res?.data?.has_contacts);
				setShowProductSection(res?.data?.has_products);
				setShowPurchaseOrderSection(res?.data?.has_purchase_orders);
				setShowImeiSection(res?.data?.has_imeis);
				setShowTrackingNumberSection(res?.data?.has_tracking_numbers);

				setSearchResultQuotation(res?.data?.quotations || []);
				setSearchResultSalesOrder(res?.data?.sales_orders || []);
				setSearchResultInvoice(res?.data?.invoices || []);
				setSearchResultContact(res?.data?.contacts || []);
				setSearchResultProduct(res?.data?.products || []);
				setSearchResultPurchaseOrder(res?.data?.purchase_orders || []);
				setSearchResultImei(res?.data?.imeis || []);
				setSearchResultTrackingNumber(res?.data?.tracking_numbers || []);


				let totalSections = 0;
				if (res?.data?.has_quotations) { totalSections += 1; }
				if (res?.data?.has_sales_orders) { totalSections += 1; }
				if (res?.data?.has_invoices) { totalSections += 1; }
				if (res?.data?.has_contacts) { totalSections += 1; }
				if (res?.data?.has_products) { totalSections += 1; }
				if (res?.data?.has_purchase_orders) { totalSections += 1; }
				if (res?.data?.has_imeis) { totalSections += 1; }
				if (res?.data?.has_tracking_numbers) { totalSections += 1; }
				
				
			}
			setIsSearchInProgress(false)
		});
	}

	 useEffect(() => {
        if (searchTimeout) clearTimeout(searchTimeout);
        if (generalSearchValue === '') return; // Don't search on empty

        const timeout = setTimeout(() => {
            getGeneralSearch();
        }, 500);

        setSearchTimeout(timeout);

        return () => clearTimeout(timeout);
    }, [generalSearchValue, location]);

	useEffect(() => {
		if (generalSearchValue.trim() === '') {
            getGeneralSearch();
		}
	}, [generalSearchValue])

	useEffect(() => {
		if (!('Notification' in window)) {
		} else {
			Notification.requestPermission();
		}
	}, []);

	useEffect(() => {
		api.userHasUnreadNotification().then((res) => {
			if (res.status) {
				dispatch(storeHasNewNotification(res?.data?.has_unread));
			}
		});
	}, []);


	useEffect(() => {
		const pusher_config = config.apps.find((c) => c?.app_urls.includes(window.location.origin))?.pusher || {};

		const pusher = new Pusher(pusher_config.key, {
			cluster: 'ap2'
		});

		const channel = pusher.subscribe('Projectmix-channel');

		// Bind to 'YourEvent' on the channel
		channel.bind(`notification-event-${userID}`, function (data) {
			
			const pushNoti = new Notification('Project Mix', {
				body: notificationTextToPlainText(data?.message?.details),
				icon: 'http://localhost:3000/img/logo-icon.png'
			});
			pushNoti.close();

			dispatch(storeHasNewNotification(true));
		});

		return () => {
			channel.unsubscribe();
		};
	}, []);

	const handleClickOutside = (event) => {
		if (notiRef.current && !notiRef.current.contains(event.target) && notiBtnRef.current && !notiBtnRef.current.contains(event.target)) {
			setShowNotifications(false);
		}
	};

	useEffect(() => {
		document.addEventListener('click', handleClickOutside, true);
		return () => {
			document.removeEventListener('click', handleClickOutside, true);
		};
	}, []);


	useEffect(() => {
		document.title = 'Projectmix';
	}, []);

    useEffect(() => {
        function handleClickOutside(event) {
            if (
                mainNavRef.current &&
                !mainNavRef.current.contains(event.target)
            ) {
                setShowSearchContainer(false);
            }
        }
        if (showSearchContainer) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showSearchContainer]);
	return (
		<>
			<nav
				id="mainNav"
				className="navbar navbar-expand navbar-light topbar m-0 static-top d-flex justify-content-between"
                ref={mainNavRef}
				style={{
					padding: "2.5rem",
				}}
			>

					<div id="nav-page-title" className="m-0" style={{ zIndex: '100' }}>
						{!!pageTitle && (
							pageTitle == 'dashboard' ? (
								<h5>Welcome back, {userName}</h5>
							) : (
								<h5 className="ml24">{pageTitle}</h5>
							)
						)}
					</div>

					<div className="nav-search" style={{ zIndex: '100' }}>
						<div className="nav-search-input">
						<div
							style={{
								zIndex: '100',
								padding: '12px 0',
								background: '#fff'
							}}
						>
							
								<input
									type="text"
									placeholder="Search"
									value={generalSearchValue}
									className={`collapse-open-width-input`}
									onChange={(e) => {
										setIsSearchInProgress(true)
										setShowQuotationSection(true);
										setShowInvoiceSection(true);
										setShowProductSection(true);
										setShowImeiSection(true);
										setShowSalesOrderSection(true);
										setShowContactSection(true);
										setShowPurchaseOrderSection(true);
										setShowTrackingNumberSection(true);
										setGeneralSearchValue(e.target.value)
									}}
									onFocus={() => setShowSearchContainer(true)}
									// onBlur={() => setShowSearchContainer(false)}
								/>
								<span className="nav-search-input-icon">
									<IoSearchOutline />
								</span>
							</div>
						



							<div
								className={`toggle-menu-search-container ${showSearchContainer ? 'show' : 'hide'}`}
								ref={searchContainerRef}
							>
								<div
									className="container-fluid"
									style={{
										padding: '0 10px'
									}}
								>
									<div style={{ width: '100%' }}>
										<div className="row">
											{
												generalSearchValue.trim() !== '' && (
													(showQuotationSection || showInvoiceSection || showProductSection || showImeiSection || showSalesOrderSection || showContactSection || showPurchaseOrderSection || showTrackingNumberSection) ? (
														<>
														
															{
																showQuotationSection && (
																	<>
																		<div className="col-12 general-search-title">
																			<div className="flex align-items-center gap-3">
																				<div>
																					<QuotationIcon height='14px' width='14px' />
																				</div>
																				<div>
																					QUOTATION
																				</div>
																			</div>
																			
																			
																		</div>
																		{
																			isSearchInProgress ? (
																				<>
																					{[...Array(5)].map((e, i) => (
																						<div className="col-12" style={{ padding: '3px 10px' }}>
																							<div className="flex gap-2 w-full">
																								<Skeleton variant="text" width="100%" height={"20px"} />
																							</div>
																						</div>
																					))}
																					<div style={{ height: '25px' }}></div>
																				</>
																			) : (
																				<>
																					{
																						searchResultQuotation.length > 0 && (
																							searchResultQuotation.map((item, index) => (
																								<div className="col-12 general-search-result-row" key={index}>
																									<div
																										className="flex gap-2 w-full"
																										onClick={() => {
																											item?.id && history(`/sales/quotations/${item?.id}`);
																											setShowSearchContainer(false)
																										}}
																									>
																										<div><ArrowRightIcon width='18px' height='18px' /></div>
																										<div className="w-full">
																											<a href="javascript:void(0);" className="fw-400 search-result-link">
																												<div className="d-flex align-items-center gap-2">
																													<div className="general-search-result">
																														<div className="d-flex align-items-center gap-2" style={{ marginTop: '-3px' }}>
																															<div className="general-search-result-value">
																																{item?.value}
																															</div>
																															<div className="d-flex align-items-center gap-1" style={{ marginTop: '-1px' }}>
																																{
																																	item?.tags?.map((tag, idx) => (
																																		tag?.value && (
																																			<Tags
																																				label={tag?.value}
																																			/>
																																		)
																																			
																																	))
																																}
																															</div>
																														</div>
																													</div>

																												</div>
																											</a>
																										</div>
																									</div>
																								</div>
																							))
																						)
																					}
																					{
																						searchResultQuotation.length > 9 && (
																							<div
																								className="col-12 mb-2 general-search-result-row"
																								style={{ fontSize: '13px' }}
																								onClick={() => {
																									history(`/sales/quotations`);
																									setShowSearchContainer(false)
																								}}
																							>
																								<a href="javascript:void(0);">See More...</a>
																							</div>
																						)
																					}	
																				</>
																			)
																		}
																	</>
																)
															}
															{
																showSalesOrderSection && (
																	<>
																		<div className="col-12 general-search-title">
																			<div className="flex align-items-center gap-3">
																				<div>
																					<SalesOrderIcon height='14px' width='14px' />
																				</div>
																				<div>
																					SALES ORDERS
																				</div>
																			</div>
																		</div>
																		{
																			isSearchInProgress ? (
																				<>
																					{[...Array(5)].map((e, i) => (
																						<div className="col-12" style={{ padding: '3px 10px' }}>
																							<div className="flex gap-2 w-full">
																								<Skeleton variant="text" width="100%" height={"20px"} />
																							</div>
																						</div>
																					))}
																					<div style={{ height: '25px' }}></div>
																				</>
																			) : (
																				<>
																					{
																						searchResultSalesOrder.length > 0 && (
																							
																							searchResultSalesOrder.map((item, index) => (
																								<div className="col-12 general-search-result-row" key={index}>
																									<div
																										className="flex gap-2 w-full"
																										onClick={() => {
																											item?.id && history(`/sales/sales-orders/${item?.id}`);
																											setShowSearchContainer(false)
																										}}
																									>
																										<div><ArrowRightIcon width='18px' height='18px' /></div>
																										<div className="w-full">
																											<a href="javascript:void(0);" className="fw-400 search-result-link">
																												<div className="d-flex align-items-center gap-2">
																													<div className="general-search-result">
																														<div className="d-flex align-items-center gap-2" style={{ marginTop: '-3px' }}>
																															<div className="general-search-result-value">
																																{item?.value}
																															</div>
																															<div className="d-flex align-items-center gap-1" style={{ marginTop: '-1px' }}>
																																{
																																	item?.tags?.map((tag, idx) => (
																																		tag?.value && (
																																			<Tags
																																				label={tag?.value}
																																			/>
																																		)
																																	
																																	))
																																}
																															</div>
																														</div>
																													</div>

																												</div>
																											</a>
																										</div>
																									</div>
																								</div>
																							))
																								
																						)
																					}
																					{
																						searchResultSalesOrder.length > 9 && (
																							<div
																								className="col-12 mb-2 general-search-result-row"
																								style={{ fontSize: '13px' }}
																								onClick={() => {
																									history(`/sales/sales-orders`);
																									setShowSearchContainer(false)
																								}}
																							>
																								<a href="javascript:void(0);">See More...</a>
																							</div>
																						)
																					}	
																				</>
																			)
																		}
																	</>
																)
															}
															{
																showInvoiceSection && (
																	<>
																		<div className="col-12 general-search-title">
																			<div className="flex align-items-center gap-3">
																				<div>
																					<InvoiceIcon height='14px' width='14px' />
																				</div>
																				<div>
																					INVOICES
																				</div>
																			</div>
																			
																		</div>
																		{
																			isSearchInProgress ? (
																				<>
																					{[...Array(5)].map((e, i) => (
																						<div className="col-12" style={{ padding: '3px 10px' }}>
																							<div className="flex gap-2 w-full">
																								<Skeleton variant="text" width="100%" height={"20px"} />
																							</div>
																						</div>
																					))}
																					<div style={{ height: '25px' }}></div>
																				</>
																			) : (
																				<>
																					{
																						searchResultInvoice.length > 0 && (
																							searchResultInvoice.map((item, index) => (
																								<div className="col-12 general-search-result-row" key={index}>
																									<div
																										className="flex gap-2 w-full"
																										onClick={() => {
																											item?.id && history(`/sales/invoices/${item?.id}`);
																											setShowSearchContainer(false)
																										}}
																									>
																										<div><ArrowRightIcon width='18px' height='18px' /></div>
																										<div className="w-full">
																											<a href="javascript:void(0);" className="fw-400 search-result-link">
																												<div className="d-flex align-items-center gap-2">
																													<div className="general-search-result">
																														<div className="d-flex align-items-center gap-2" style={{ marginTop: '-3px' }}>
																															<div className="general-search-result-value">
																																{item?.value}
																															</div>
																															<div className="d-flex align-items-center gap-1" style={{ marginTop: '-1px' }}>
																																{
																																	item?.tags?.map((tag, idx) => (
																																		tag?.value && (
																																			<Tags
																																				label={tag?.value}
																																			/>
																																		)
																																	))
																																}
																															</div>
																														</div>
																													</div>

																												</div>
																											</a>
																										</div>
																									</div>
																								</div>
																							))
																						)
																					}
																					{
																						searchResultInvoice.length > 9 && (
																							<div
																								className="col-12 mb-2 general-search-result-row"
																								style={{ fontSize: '13px' }}
																								onClick={() => {
																									history(`/sales/invoices`);
																									setShowSearchContainer(false)
																								}}
																							>
																								<a href="javascript:void(0);">See More...</a>
																							</div>
																						)
																					}	
																				</>
																			)
																		}
																	</>
																)
															}
															{
																showContactSection && (
																	<>
																		<div className="col-12 general-search-title">
																			<div className="flex align-items-center gap-3">
																				<div>
																					<ContactsIcons height='14px' width='14px' />
																				</div>
																				<div>
																					CONTACTS
																				</div>
																			</div>
																			
																		</div>
																		{
																			isSearchInProgress ? (
																				<>
																					{[...Array(5)].map((e, i) => (
																						<div className="col-12" style={{ padding: '3px 10px' }}>
																							<div className="flex gap-2 w-full">
																								<Skeleton variant="text" width="100%" height={"20px"} />
																							</div>
																						</div>
																					))}
																					<div style={{ height: '25px' }}></div>
																				</>
																			) : (
																				<>
																					{
																						searchResultContact.length > 0 && (
																							searchResultContact.map((item, index) => (
																								<div className="col-12 general-search-result-row" key={index}>
																									<div
																										className="flex gap-2 w-full"
																										onClick={() => {
																											item?.id && history(`/contacts/${item?.id}`);
																											setShowSearchContainer(false)
																										}}
																									>
																										<div><ArrowRightIcon width='18px' height='18px' /></div>
																										<div className="w-full">
																											<a href="javascript:void(0);" className="fw-400 search-result-link">
																												<div className="d-flex align-items-center gap-2">
																													<div className="general-search-result">
																														<div className="d-flex align-items-center gap-2" style={{ marginTop: '-3px' }}>
																															<div className="general-search-result-value">
																																{item?.value}
																															</div>
																															<div className="d-flex align-items-center gap-1" style={{ marginTop: '-1px' }}>
																																{
																																	item?.tags?.map((tag, idx) => (
																																		tag?.value && (
																																			tag?.key === 'Country' ? (
																																				<div style={{ padding: '0px 5px', fontSize: '16px' }}>
																																					<CountriesUIFlag countryName={`${tag?.value}`} />
																																				</div>
																																			) : (
																																				<div className="general-search-tag-container text-gray-800">
																																					{ tag?.value }
																																				</div>
																																			)
																																		)
																																	))
																																}
																															</div>
																														</div>
																													</div>

																												</div>
																											</a>
																										</div>
																									</div>
																								</div>
																							))
																						)
																					}
																					{
																						searchResultContact.length > 9 && (
																							<div
																								className="col-12 mb-2 general-search-result-row"
																								style={{ fontSize: '13px' }}
																								onClick={() => {
																									history(`/contacts`);
																									setShowSearchContainer(false)
																								}}
																							>
																								<a href="javascript:void(0);">See More...</a>
																							</div>
																						)
																					}	
																				</>
																			)
																		}
																	</>
																)
															}
															{
																showPurchaseOrderSection && (
																	<>
																		<div className="col-12 general-search-title">
																			<div className="flex align-items-center gap-3">
																				<div>
																					<PurchaseListIcon height='14px' width='14px' />
																				</div>
																				<div>
																					PURCHASE ORDERS
																				</div>
																			</div>
																		</div>
																		{
																			isSearchInProgress ? (
																				<>
																					{[...Array(5)].map((e, i) => (
																						<div className="col-12" style={{ padding: '3px 10px' }}>
																							<div className="flex gap-2 w-full">
																								<Skeleton variant="text" width="100%" height={"20px"} />
																							</div>
																						</div>
																					))}
																					<div style={{ height: '25px' }}></div>
																				</>
																			) : (
																				<>
																					{
																						searchResultPurchaseOrder.length > 0 && (
																							searchResultPurchaseOrder.map((item, index) => (
																								<div className="col-12 general-search-result-row" key={index}>
																									<div
																										className="flex gap-2 w-full"
																										onClick={() => {
																											item?.id && history(`/purchasing/${item?.id}`);
																											setShowSearchContainer(false)
																										}}
																									>
																										<div><ArrowRightIcon width='18px' height='18px' /></div>
																										<div className="w-full">
																											<a href="javascript:void(0);" className="fw-400 search-result-link">
																												<div className="d-flex align-items-center gap-2">
																													<div className="general-search-result">
																														<div className="d-flex align-items-center gap-2" style={{ marginTop: '-3px' }}>
																															<div className="general-search-result-value">
																																{item?.value}
																															</div>
																															<div className="d-flex align-items-center gap-1" style={{ marginTop: '-1px' }}>
																																{
																																	item?.tags?.map((tag, idx) => (
																																		tag?.value && (
																																			<Tags
																																				label={tag?.value}
																																			/>
																																		)
																																	))
																																}
																															</div>
																														</div>
																													</div>

																												</div>
																											</a>
																										</div>
																									</div>
																								</div>
																							))
																						)
																					}
																					{
																						searchResultPurchaseOrder.length > 9 && (
																							<div
																								className="col-12 mb-2 general-search-result-row"
																								style={{ fontSize: '13px' }}
																								onClick={() => {
																									history(`/purchasing`);
																									setShowSearchContainer(false)
																								}}
																							>
																								<a href="javascript:void(0);">See More...</a>
																							</div>
																						)
																					}	
																				</>
																			)
																		}
																	</>
																)
															}
															{
																showProductSection && (
																	<>
																		<div className="col-12 general-search-title">
																			<div className="flex align-items-center gap-3">
																				<div>
																					<HiOutlineDeviceMobile style={{ fontSize: '1.3em' }} />
																				</div>
																				<div>
																					PRODUCTS
																				</div>
																			</div>
																			
																		</div>
																		{
																			isSearchInProgress ? (
																				<>
																					{[...Array(5)].map((e, i) => (
																						<div className="col-12" style={{ padding: '3px 10px' }}>
																							<div className="flex gap-2 w-full">
																								<Skeleton variant="text" width="100%" height={"20px"} />
																							</div>
																						</div>
																					))}
																					<div style={{ height: '25px' }}></div>
																				</>
																			) : (
																				<>
																					{
																						searchResultProduct.length > 0 && (
																							searchResultProduct.map((item, index) => (
																								<div className="col-12 general-search-result-row" key={index}>
																									<div
																										className="flex gap-2 w-full"
																										onClick={() => {
																											item?.id && history(`/products/${item?.id}`);
																											setShowSearchContainer(false)
																										}}
																									>
																										<div><ArrowRightIcon width='18px' height='18px' /></div>
																										<div className="w-full">
																											<a href="javascript:void(0);" className="fw-400 search-result-link">
																												<div className="d-flex align-items-center gap-2">
																													<div className="general-search-result">
																														<div className="d-flex align-items-center gap-2" style={{ marginTop: '-3px' }}>
																															<div className="general-search-result-value">
																																{item?.value}
																															</div>
																															<div className="d-flex align-items-center gap-1" style={{ marginTop: '-1px' }}>
																																{
																																	item?.tags?.map((tag, idx) => (
																																		tag?.value && (
																																			<Tags
																																				label={tag?.value}
																																			/>
																																		)
																																	))
																																}
																															</div>
																														</div>
																													</div>

																												</div>
																											</a>
																										</div>
																									</div>
																								</div>
																							))
																						)
																					}
																					{
																						searchResultProduct.length > 9 && (
																							<div
																								className="col-12 mb-2 general-search-result-row"
																								style={{ fontSize: '13px' }}
																								onClick={() => {
																									history(`/products`);
																									setShowSearchContainer(false)
																								}}
																							>
																								<a href="javascript:void(0);">See More...</a>
																							</div>
																						)
																					}	
																				</>
																			)
																		}
																	</>
																)
															}
															{
																showImeiSection && (
																	<>
																		<div className="col-12 general-search-title">
																			<div className="flex align-items-center gap-3">
																				<div>
																					<SerialsIcon height='14px' width='14px' />
																				</div>
																				<div>
																					IMEIS
																				</div>
																			</div>
																			
																		</div>
																		{
																			isSearchInProgress ? (
																				<>
																					{[...Array(5)].map((e, i) => (
																						<div className="col-12" style={{ padding: '3px 10px' }}>
																							<div className="flex gap-2 w-full">
																								<Skeleton variant="text" width="100%" height={"20px"} />
																							</div>
																						</div>
																					))}
																					<div style={{ height: '25px' }}></div>
																				</>
																			) : (
																				<>
																					{
																						searchResultImei.length > 0 && (
																							searchResultImei.map((item, index) => (
																								<div className="col-12 general-search-result-row" key={index}>
																									<div
																										className="flex gap-2 w-full"
																										onClick={() => {
																											item?.id && history(`/serials/${item?.id}`);
																											setShowSearchContainer(false)
																										}}
																									>
																										<div><ArrowRightIcon width='18px' height='18px' /></div>
																										<div className="w-full">
																											<a href="javascript:void(0);" className="fw-400 search-result-link">
																												<div className="d-flex align-items-center gap-2">
																													<div className="general-search-result">
																														<div className="d-flex align-items-center gap-2" style={{ marginTop: '-3px' }}>
																															<div className="general-search-result-value">
																																{item?.value}
																															</div>
																															<div className="d-flex align-items-center gap-1" style={{ marginTop: '-1px' }}>
																																{
																																	item?.tags?.map((tag, idx) => (
																																		tag?.value && (
																																			<Tags
																																				label={tag?.value}
																																			/>
																																		)
																																	))
																																}
																															</div>
																														</div>
																													</div>

																												</div>
																											</a>
																										</div>
																									</div>
																								</div>
																							))
																						)
																					}
																					{
																						searchResultImei.length > 9 && (
																							<div
																								className="col-12 mb-2 general-search-result-row"
																								style={{ fontSize: '13px' }}
																								onClick={() => {
																									history(`/serials`);
																									setShowSearchContainer(false)
																								}}
																							>
																								<a href="javascript:void(0);">See More...</a>
																							</div>
																						)
																					}	
																				</>
																			)
																		}
																	</>
																)
															}
															{
																showTrackingNumberSection && (
																	<>
																		<div className="col-12 general-search-title">
																		
																			<div className="flex align-items-center gap-3">
																				<div>
																					<TrackingCodeIcon height='14px' width='14px' />
																				</div>
																				<div>
																					TRACKING NUMBERS
																				</div>
																			</div>
																		
																		</div>
																		{
																			isSearchInProgress ? (
																				<>
																					{[...Array(5)].map((e, i) => (
																						<div className="col-12" style={{ padding: '3px 10px' }}>
																							<div className="flex gap-2 w-full">
																								<Skeleton variant="text" width="100%" height={"20px"} />
																							</div>
																						</div>
																					))}
																					<div style={{ height: '25px' }}></div>
																				</>
																			) : (
																				<>
																					{
																						searchResultTrackingNumber.length > 0 && (
																							searchResultTrackingNumber.map((item, index) => (
																								<div className="col-12 general-search-result-row" key={index}>
																									<div
																										className="flex gap-2 w-full"
																										onClick={() => {
																											item?.id && history(`/shipments/${item?.id}`);
																											setShowSearchContainer(false)
																										}}
																									>
																										<div><ArrowRightIcon width='18px' height='18px' /></div>
																										<div className="w-full">
																											<a href="javascript:void(0);" className="fw-400 search-result-link">
																												<div className="d-flex align-items-center gap-2">
																													<div className="general-search-result">
																														<div className="d-flex align-items-center gap-2" style={{ marginTop: '-3px' }}>
																															<div className="general-search-result-value">
																																{item?.value}
																															</div>
																															<div className="d-flex align-items-center gap-1" style={{ marginTop: '-1px' }}>
																																{
																																	item?.tags?.map((tag, idx) => (
																																		tag && (
																																			<Tags
																																				label={tag}
																																			/>
																																		)
																																	))
																																}
																															</div>
																														</div>
																													</div>

																												</div>
																											</a>
																										</div>
																									</div>
																								</div>
																							))
																						)
																					}
																					{
																						searchResultTrackingNumber.length > 9 && (
																							<div
																								className="col-12 mb-2 general-search-result-row"
																								style={{ fontSize: '13px' }}
																								onClick={() => {
																									history(`/shipments`);
																									setShowSearchContainer(false)
																								}}
																							>
																								<a href="javascript:void(0);">See More...</a>
																							</div>
																						)
																					}	
																				</>
																			)
																		}
																	</>
																)
															}
														</>
													) : (
														<div className="col-12">
															<div className="no-general-search-result">
																<div>No search result found for: </div>
																<div className="fw-500 text-gray-900 ">{generalSearchValue}</div>
															</div>
														</div>
													)
												)
											}

										</div>
									</div>
								</div>
							</div>





						</div>
					</div>

					<div className="nav-actions" style={{ zIndex: '100' }}>
						<div>
							<TaskSection taskPanelOpened={taskPanelOpened} setTaskPanelOpened={setTaskPanelOpened} />
						</div>
						<div>
							<a
								className="nav-link dropdown-toggle"
								href="#"
								id="alertsDropdown"
								role="button"
								data-toggle="dropdown"
								aria-haspopup="true"
								aria-expanded="false"
								onClick={() => setShowNotifications(!showNotifications)}
								ref={notiBtnRef}
							>
								<NotificationIcon width={15} height={15} />

								{hasNewNotification && <span className="badge badge-danger badge-counter noti-badge">&nbsp;</span>}
							</a>
							<div className="notification-box" ref={notiRef}>
								{showNotifications && (
									<NotificationDropdown
										closeNotificationBox={() => {
											setShowNotifications(false);
										}}
									/>
								)}
							</div>
						</div>
						<div>
							<QuickActions isOpened={true} />
						</div>
						<div style={{ position: 'relative' }}>
							<div
								className="user-icon-item"
								onClick={() => {
									setShowProfileMenu(!showProfileMenu);
								}}
								ref={profileIconRef}
							>
								<Avatar
									sx={{ width: 25, height: 25 }}
									style={{ fontSize: 8 }}
									src={profilePhoto ? profilePhoto : 'https://cdn.iconscout.com/icon/free/png-256/free-avatar-380-456332.png'}
								>
									{userFName ? userFName?.[0] : ''}
									{userLName ? userLName?.[0] : ''}
								</Avatar>
								<IoIosArrowDown />
							</div>
							{showProfileMenu && <ProfileMenuBlock mainIconRef={profileIconRef} onCloseMenu={() => setShowProfileMenu(false)} />}

						</div>
					</div>

			</nav>
			{
				generalSearchValue.trim() !== '' && (
					<div className={`search-overlay ${showSearchContainer ? 'show' : ''}`}></div>
				)
			}
		</>
	);
};

export default NavBar;

// const CustomToggle = React.forwardRef(({ children, onClick }, ref) => {
// 	return (
// 		<Link
// 			className="nav-link dropdown-toggle "
// 			to="#"
// 			id="userDropdown"
// 			role="button"
// 			data-toggle="dropdown"
// 			aria-haspopup="true"
// 			aria-expanded="false"
// 			onClick={onClick}
// 		>
// 			{children}
// 		</Link>
// 	);
// });
